module.exports = __webpack_public_path__ + "abc90cbafbf1a2421ed18ee8af9c3b11.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/va.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/va.svg
// module chunks = 0